import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from '../../common/data2.service';
import { TourismSchedulesFiltersComponent } from './tourism-schedules-filters/tourism-schedules-filters.component';

@Component({
	selector: 'app-tourism-schedules',
	templateUrl: './tourism-schedules.component.html',
	styleUrls: ['./tourism-schedules.component.css'],
})
export class TourismSchedulesComponent {
	private readonly itemsBeforeDataLoad = 0;
	loader = true;
	data: Array<any> = [];
	filters = {};
	tableRows = [
		{
			id: 'created',
			name: 'Utworzono',
		},
		{
			id: 'username',
			name: 'Przez',
		},
		{
			id: 'accommodationFrom',
			name: 'Zakwaterowanie',
		},
		{
			id: 'season',
			name: 'Kierunek',
		},
		{
			id: 'side',
			name: 'Strona',
		},
	];

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
		protected router: Router,
	) {}

	loadData() {
		this.api.get('/tourismTimetable/', (result, error) => {
			result.data.forEach((obj) => {
				obj.season = [];
				obj.seasons.forEach((season) => {
					obj.season.push(season.destinationName);
				});
				obj.season = obj.season.join(', ');
				obj.departureDate = obj.seasons[0]?.departureDate;
				obj.accommodationFrom = obj.seasons[0]?.accommodationFrom;
				switch (obj.side) {
					case 'departure':
						obj.side = 'Wyjazd';
						break;
					case 'return':
						obj.side = 'Powrót';
						break;
				}
			});
			this.data = result.data;
			this.loader = false;
		});
	}

	filtersOpen() {
		new TourismSchedulesFiltersComponent(this.api, this.route, this.router).filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}
}
